import React, { useState, useEffect } from "react";
import { Card, CardActionArea, CardContent, Fab, Grid, IconButton } from "@material-ui/core";
import blue from "@material-ui/core/colors/blue";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import { makeStyles } from '@material-ui/core/styles';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import UseFetchData from "../../hooks/UseFetchData";

let Mode = 'Insert';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 250,
    //width: '100%',
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end"
  },
  input: {
    display: "none"
  },
  button: {
    color: blue[900],
    marginTop: 16,
  },
  buttonEdit: {
    position: 'absolute',
    top: "0%",
    color: blue[500],
    marginTop: 7,
    width: '0px',
    height: '0px',
  },
  cardName: {
    maxWidth: 250,
    //width: '100%',
  },
  container: {
    position: 'relative',
    width: '100%',
    maxWidth: '400px',
  },
  btn: {
    position: 'absolute',
    top: -9,
    left: '75%',
    border: 'none',
    cursor: 'pointer',
    borderRadius: '5px',
  },
  btn2: {
    position: 'absolute',
    top: -9,
    left: '75%',
    border: 'none',
    cursor: 'pointer',
    borderRadius: '5px',
  },
  btn3: {
    position: 'absolute',
    top: -9,
    left: '85%',
    border: 'none',
    cursor: 'pointer',
    borderRadius: '5px',
  },
  div: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default function ImageAttachment(props) {
  const classes = useStyles();
  const [MainState, setMainState] = useState('initial');
  const [SelectedImage, setSelectedImage] = useState(null);
  const [ImageUploaded, setImageUploaded] = useState(0);
  const [btnDisable, setbtnDisable] = useState(false);
  const [viewImage, setviewImage] = useState('');
  const [AttachID, setAttachID] = useState('');
  const [FileName, setFileName] = useState('');
  const [responseUpload, UploadData] = UseFetchData();
  //const { mainState, setMainState, btnDisable, SelectedImage, setSelectedImage, setImageUploaded, handleUploadClick } = props;
  const [responseDelete, fetchDeleteData] = UseFetchData();
  const [responseViewData, fetchViewData] = UseFetchData();

  const EditImage = event => {
    try {
      Mode = 'Update';
      var file = event.target.files[0];
      var FName = file.name;
      var FileExtension = file.name.split('.')[1];
      var Base64 = null;
      const reader = new FileReader();
      var url = reader.readAsDataURL(file);
      reader.onloadend = function (e) {
        setSelectedImage([reader.result]);
        Base64 = [reader.result];
        setMainState("uploaded")
        if (MainState === "uploaded") {
          setImageUploaded(1);
          //setSelectedImage(event.target.files[0])
        }
        onUploadFile(FName, FileExtension, Base64);
      };
    }
    catch (error) {
      console.log(error);
    }
  }

  const handleUploadClick = event => {
    try {
      var file = event.target.files[0];
      var FName = file.name;
      var FileExtension = file.name.split('.')[1];
      var Base64 = null;
      const reader = new FileReader();
      var url = reader.readAsDataURL(file);
      reader.onloadend = function (e) {
        setSelectedImage([reader.result]);
        Base64 = [reader.result];
        setMainState("uploaded")
        if (MainState === "uploaded") {
          setImageUploaded(1);
          setSelectedImage(event.target.files[0])
        }
        onUploadFile(FName, FileExtension, Base64);
      };
    }
    catch (error) {
      console.log(error);
    }
  };

  const onUploadFile = (FName, FileExtension, Base64) => {
    // debugger;
    var UserID = sessionStorage.UID;
    var bodyFormData = new FormData();
    bodyFormData.append("Type", "Image");
    bodyFormData.append("Group", props.Group);
    bodyFormData.append("RefDocumentID", props.RefDocumentID);
    bodyFormData.append("FileExtension", FileExtension);
    // bodyFormData.append("FileName", FileName);
    bodyFormData.append("FileName", FName);

    // debugger;
    if (Mode === 'Insert') {
      bodyFormData.append("AttachmentID", '');
    }
    else {
      bodyFormData.append("AttachmentID", AttachID);
    }
    bodyFormData.append("FileDescription", "Testing");
    bodyFormData.append("UserID", UserID);
    bodyFormData.append("FileString", Base64[0].split(',')[1]);
    UploadData("Activity/Attachment", bodyFormData);
  }

  const PopulateData = () => {
    var bodyFormData = new FormData();
    //'8857a581-32de-4e44-9050-cb4900d72cf1'
    bodyFormData.append("RefDocumentID", props.RefDocumentID);
    bodyFormData.append("AttachmentType", props.Type);
    fetchViewData("Activity/GetAttachmentDtls", bodyFormData);
  }

  useEffect(() => {
    // debugger;
    if (responseViewData !== undefined) {
      if (responseViewData.length > 0) {
        if (responseViewData[0].FilePath !== "") {
          setviewImage(responseViewData[0].FilePath);
          setAttachID(responseViewData[0].id);
          setFileName(responseViewData[0].FileName)
          setMainState('uploaded');
        }
      }
    }
  }, [responseViewData])

  useEffect(() => {
    // debugger;
    if (responseUpload.Response === true) {
      setMainState('uploaded');
      PopulateData();
    }
  }, [responseUpload])

  useEffect(() => {
    // debugger;
    if (responseDelete.Response === true) {
      PopulateData();
      setMainState('initial');
    }
  }, [responseDelete])

  useEffect(() => {
    // debugger;
    PopulateData();
  }, [])

  const DeleteAttachment = () => {
    // debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("PKID", AttachID);
    bodyFormData.append("Type", props.Type);
    fetchDeleteData("Activity/DeleteAttachment", bodyFormData);
  }

  const ViewImageOnPage = () => {
    window.open(viewImage);
  }

  const renderInitialState = () => {
    return (
      <React.Fragment>
        <CardContent style={{ width: 250, height: 120 }}>
          <Grid container justify="center" alignItems="center">
            <input
              accept="image/*"
              className={classes.input}
              id={props.id}
              multiple
              type="file"
              disabled={btnDisable}
              onChange={handleUploadClick}
            />
            <label htmlFor={props.id}>
              <Fab component="span" className={classes.button}>
                <AddPhotoAlternateIcon />
              </Fab>
            </label>
          </Grid>
        </CardContent>
      </React.Fragment>
    );
  }

  const renderUploadedState = () => {
    return (
      <React.Fragment>
        <CardActionArea /* onClick={ViewImageOnPage} */ style={{ width: 250, height: 120 }}>
          <div className={classes.container}>
            <img
              style={{ width: 250, height: 120 }}
              src={viewImage}
            />
            <div style={{ width: '100%' }}>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div>
                  <IconButton style={{ color: blue[500] }} className={classes.btn} component="span" onClick={() => { ViewImageOnPage(); }} >
                    <ImageSearchIcon />
                  </IconButton>
                  <div className={classes.btn2} >
                    <input
                      accept="image/*"
                      className={classes.input}
                      id={props.id}
                      multiple
                      type="file"
                      disabled={btnDisable}
                      onChange={EditImage}
                    />
                    <label htmlFor={props.id}>
                      <Fab component="span" className={classes.buttonEdit}>
                        <EditIcon />
                      </Fab>
                    </label>
                  </div>
                  <IconButton style={{ color: 'red' }} className={classes.btn3} aria-label="delete" onClick={() => { DeleteAttachment(); }} >
                    <DeleteIcon />
                  </IconButton>
                </div>
              </div>
            </div>
          </div>
        </CardActionArea>
      </React.Fragment>
    );
  }

  const imageResetHandler = () => {
    setMainState("initial");
    setSelectedImage(null);
    setImageUploaded(0);
  };

  return (
    <div className={classes.div}>
      <React.Fragment>
        <div className={classes.root}>
          <Card className={classes.cardName}>
            {(MainState === "initial" && renderInitialState()) ||
              (MainState === "uploaded" && renderUploadedState())}
          </Card>
        </div>
      </React.Fragment>
    </div>
  );
}